import { useRef } from 'react';

export default (fn, time = 0) => {
  const timmer = useRef();

  return (...args) => {
    if (timmer.current) {
      clearTimeout(timmer.current);
    }

    timmer.current = setTimeout(() => {
      fn(...args);
      timmer.current = null;
    }, time);
  };
};
